import { render, staticRenderFns } from "./storageAccumView.vue?vue&type=template&id=16dcd9b6&"
import script from "./storageAccumView.vue?vue&type=script&lang=js&"
export * from "./storageAccumView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports